import { useSuspenseQuery } from '@tanstack/react-query';

import {
  getAwardValidationOptions,
  useValidateAward,
} from '@/module/Author/Award/Validation/model/AwardValidationModel';

import { Id, useAppNotification } from '@feature/utils';
import { ValidationRequest, ValidationVariant } from '@feature/validation';
import { ValidationAction } from '@feature/validation/ValidationAction';

interface ValidationActionProps {
  awardId: Id;
  variant?: ValidationVariant;
}

export function AwardValidationAction({ awardId, variant }: ValidationActionProps) {
  const { data } = useSuspenseQuery(getAwardValidationOptions(awardId));
  const notification = useAppNotification();
  const { mutate, isPending } = useValidateAward(awardId);

  const onSubmit = (request: ValidationRequest) => {
    mutate(request, {
      onSuccess: notification.success,
      onError: notification.error,
    });
  };

  return (
    <ValidationAction
      validation={data}
      isPending={isPending}
      onSubmit={onSubmit}
      variant={variant}
    />
  );
}
